export default __webpack_public_path__ + "i18n/translation-ko.358e790a.json";